import React from "react";

export default function SQL_INSERT_INTO() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_INSERT_INTO</h1>
      <p>This is the SQL_INSERT_INTO component generated from the SQL JSON.</p>
    </div>
  );
}
